import { render, staticRenderFns } from "./GeneralEmailConfirmation.vue?vue&type=template&id=3e840342&scoped=true&lang=pug&"
import script from "./GeneralEmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./GeneralEmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEmailConfirmation.vue?vue&type=style&index=0&id=3e840342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e840342",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow,VSpacer})
